/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/naming-convention */
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {ApiEnum} from 'src/app/shared/constants/api.enum';
import AppConstant from 'src/app/shared/constants/app.constant';
import {RouteEnum} from 'src/app/shared/constants/route.enum';
import {AppHttpService} from 'src/app/shared/service/http/app-http.service';
import {AppStorageService} from 'src/app/shared/service/storage/app-storage.service';
import {ToastService} from 'src/app/shared/service/toast/toast.service';
import {CredentialLoginRequest} from '../model/credential-login.request';
import {ILogoutResp} from '../model/ILogoutResp';
import {LoginRequest} from '../model/login.request';
import {ILoginResponse} from '../model/login.resp';
import {IVerifyOtpReq} from '../model/verify.otp.request';
import {VerifyOtpResp} from '../model/verify.otp.resp';
import {Location} from '@angular/common';
import {ForgotPasswordInitiateRequest, ForgotPasswordConfirmRequest} from '../model/forgot-password.request';
import {FirstTimeResetRequest, ExpiredPasswordResetInitiateRequest, ExpiredPasswordResetConfirmRequest} from '../model/reset-password.request';
import {PasswordResetResponse} from '../model/password-reset.resp';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private readonly httpService: AppHttpService,
    private readonly httpClient: HttpClient,
    private readonly storageSvc: AppStorageService,
    private readonly router: Router,
    private readonly toastSvc: ToastService,
    private readonly location: Location
  ) {}

  validateCredentials(req: CredentialLoginRequest): Observable<ILoginResponse> {
    return this.httpService.post(`${ApiEnum.LOGIN_BASE_URL}/validate_credentials`, req);
  }

  authenticate(req: LoginRequest): Observable<ILoginResponse> {
    return this.httpService.post(`${ApiEnum.LOGIN_BASE_URL}/authenticate`, req);
  }

  verifyOtp(req: IVerifyOtpReq): Observable<VerifyOtpResp> {
    return this.httpService.post(`${ApiEnum.LOGIN_BASE_URL}/verify_otp`, req);
  }

  // Forgot Password Flow
  forgotPasswordInitiate(req: ForgotPasswordInitiateRequest): Observable<ILoginResponse> {
    return this.httpService.post(`${ApiEnum.LOGIN_BASE_URL}/forgot_password_initiate`, req);
  }

  forgotPasswordConfirm(req: ForgotPasswordConfirmRequest): Observable<PasswordResetResponse> {
    return this.httpService.post(`${ApiEnum.LOGIN_BASE_URL}/forgot_password_confirm`, req);
  }

  // First Time Login Flow
  firstTimeReset(req: FirstTimeResetRequest): Observable<PasswordResetResponse> {
    return this.httpService.post(`${ApiEnum.LOGIN_BASE_URL}/first_time_reset`, req);
  }

  // Expired Password Flow
  expiredPasswordResetInitiate(req: ExpiredPasswordResetInitiateRequest): Observable<ILoginResponse> {
    return this.httpService.post(`${ApiEnum.LOGIN_BASE_URL}/expired_password_reset_initiate`, req);
  }

  expiredPasswordResetConfirm(req: ExpiredPasswordResetConfirmRequest): Observable<PasswordResetResponse> {
    return this.httpService.post(`${ApiEnum.LOGIN_BASE_URL}/expired_password_reset_confirm`, req);
  }

  getToken(refToken: string): Observable<VerifyOtpResp> {
    const httpHeaders: HttpHeaders = new HttpHeaders({
      'x-refresh-token': refToken,
    });
    return this.httpClient.post<VerifyOtpResp>(`${ApiEnum.LOGIN_BASE_URL}/refresh`, null, {
      headers: httpHeaders,
    });
  }

  async logOut(skipLogoutApi = false): Promise<void> {
    const accessToken = this.storageSvc.getItem(AppConstant.STORAGE_KEYS.SIT_T) as string;
    const refreshToken = this.storageSvc.getItem(AppConstant.STORAGE_KEYS.SIT_R_T) as string;
    const webexToken = this.storageSvc.getItem(AppConstant.STORAGE_KEYS.SIT_WBX_TKN) as string;
    const httpHeaders: HttpHeaders = new HttpHeaders({
      'x-refresh-token': refreshToken,
      'x-access-token': accessToken,
      'x-webex-token': webexToken,
    });
    if (!skipLogoutApi) {
      this.httpClient
        .post<ILogoutResp>(`${ApiEnum.LOGIN_BASE_URL}/logout`, null, {
          headers: httpHeaders,
        })
        .subscribe(async (resp: ILogoutResp) => {
          console.log('Resp from Logout###', resp);
        });
    }
    this.storageSvc.clear();
    void this.router.navigate([`${RouteEnum.DELAER_BASE_LOGIN_URL}`]);
    this.location.historyGo(0);
  }
}
